import * as i1$2 from '@ngrx/store';
import { createAction, props, createReducer, on, StoreModule, createFeatureSelector, createSelector, select } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1$1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError, filter, take, tap } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { isEmpty } from 'lodash';
import { COMMON_APP_CONFIG } from '@rogers/self-serve-common';
import { createEntityAdapter } from '@ngrx/entity';
var AlertContentActionTypes = /*#__PURE__*/function (AlertContentActionTypes) {
  AlertContentActionTypes["ClearAlertContents"] = "[AlertContent] Clear Alert contents";
  AlertContentActionTypes["FetchAlertContent"] = "[AlertContent] Fetch Alert content";
  AlertContentActionTypes["FetchAlertContentFail"] = "[AlertContent] Fetch Alert content Fail";
  AlertContentActionTypes["FetchAlertContentSuccess"] = "[AlertContent] Fetch Alert content Success";
  return AlertContentActionTypes;
}(AlertContentActionTypes || {});
const clearAlertContents = createAction(AlertContentActionTypes.ClearAlertContents);
const fetchAlertContent = createAction(AlertContentActionTypes.FetchAlertContent, props());
const fetchAlertContentFail = createAction(AlertContentActionTypes.FetchAlertContentFail, props());
const fetchAlertContentSuccess = createAction(AlertContentActionTypes.FetchAlertContentSuccess, props());
let AlertContentService = /*#__PURE__*/(() => {
  class AlertContentService {
    constructor(appConfig, http) {
      this.appConfig = appConfig;
      this.http = http;
    }
    getAlertContent$(pageName, language) {
      return this.fetchAlertContent$(pageName, language).pipe(map(alertContentRespose => {
        if (isEmpty(alertContentRespose?.content)) {
          return {
            alerts: []
          };
        }
        const alertContentDetails = alertContentRespose.content;
        return {
          alerts: this.transformAlertContent(alertContentDetails)
        };
      }));
    }
    fetchAlertContent$(pageName, language) {
      const url = `${this.appConfig.contentBaseUrl}alert-content/${pageName}`;
      return this.http.get(url, {
        headers: this.appConfig.getHeaders(language)
      });
    }
    transformAlertContent(alertContentDetails) {
      return alertContentDetails.filter(alertContent => !isEmpty(alertContent.copy)).map(alertContent => {
        return {
          alertId: alertContent.alertId,
          closeAltText: alertContent.closeAltText,
          copy: alertContent.copy,
          cta: alertContent.cta,
          dismissible: alertContent.dismissible,
          variant: alertContent.alertType
        };
      });
    }
    static {
      this.ɵfac = function AlertContentService_Factory(t) {
        return new (t || AlertContentService)(i0.ɵɵinject(COMMON_APP_CONFIG), i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertContentService,
        factory: AlertContentService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AlertContentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertContentEffects = /*#__PURE__*/(() => {
  class AlertContentEffects {
    constructor(actions$, alertContentService) {
      this.actions$ = actions$;
      this.alertContentService = alertContentService;
      this.loadAlertContent$ = createEffect(() => this.actions$.pipe(ofType(AlertContentActionTypes.FetchAlertContent), mergeMap(payload => {
        const {
          language,
          pageName
        } = payload;
        return this.alertContentService.getAlertContent$(pageName, language).pipe(map(alertContent => {
          return fetchAlertContentSuccess({
            ...payload,
            alertContent
          });
        }), catchError(() => {
          return of(fetchAlertContentFail(payload));
        }));
      })));
    }
    static {
      this.ɵfac = function AlertContentEffects_Factory(t) {
        return new (t || AlertContentEffects)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(AlertContentService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertContentEffects,
        factory: AlertContentEffects.ɵfac
      });
    }
  }
  return AlertContentEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const alertContentFeatureKey = 'alertContent';
const adapter = createEntityAdapter({
  selectId: alertContentEntity => `${alertContentEntity.pageName}_${alertContentEntity.language}`
});
const initialState = adapter.getInitialState({
  ids: []
});
const createAlertContentReducer = createReducer(initialState, on(clearAlertContents, state => adapter.removeAll(state)), on(fetchAlertContent, (state, {
  language,
  pageName
}) => {
  return adapter.upsertOne({
    alerts: [],
    language,
    pageName,
    hasError: false,
    loading: true,
    loaded: false
  }, state);
}), on(fetchAlertContentFail, (state, {
  language,
  pageName
}) => adapter.upsertOne({
  alerts: [],
  hasError: true,
  language,
  loading: false,
  loaded: false,
  pageName
}, state)), on(fetchAlertContentSuccess, (state, {
  language,
  pageName,
  alertContent
}) => adapter.upsertOne({
  ...alertContent,
  hasError: false,
  language,
  loading: false,
  loaded: true,
  pageName
}, state)));
const alertContentReducer = (state, action) => {
  return createAlertContentReducer(state, action);
};
const {
  selectEntities: selectEntities$1
} = adapter.getSelectors();
let AlertContentStoreModule = /*#__PURE__*/(() => {
  class AlertContentStoreModule {
    static {
      this.ɵfac = function AlertContentStoreModule_Factory(t) {
        return new (t || AlertContentStoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AlertContentStoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, StoreModule.forFeature(alertContentFeatureKey, alertContentReducer), EffectsModule.forFeature([AlertContentEffects])]
      });
    }
  }
  return AlertContentStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const AlertContentState = createFeatureSelector(alertContentFeatureKey);
const {
  selectEntities
} = adapter.getSelectors();
const getAlertContentOrDefault = (AlertContentEntities, pageName, language) => {
  const key = `${pageName}_${language}`;
  let AlertContentEntity = AlertContentEntities[key];
  if (!AlertContentEntity) {
    AlertContentEntity = {
      alerts: [],
      language,
      loaded: false,
      loading: false,
      pageName
    };
  }
  return AlertContentEntity;
};
const AlertContentEntities = createSelector(AlertContentState, selectEntities);
const getAlertContent = createSelector(AlertContentEntities, entities => (pageName, language) => getAlertContentOrDefault(entities, pageName, language));
const getAlertContentByLang = (pageName, lang) => createSelector(getAlertContent, f => f(pageName, lang));
let AlertContentFacadeService = /*#__PURE__*/(() => {
  class AlertContentFacadeService {
    constructor(store) {
      this.store = store;
    }
    clearAlertContents() {
      return this.store.dispatch(clearAlertContents());
    }
    getAlertContents$(pageName, language) {
      this.fetchAlertContent(pageName, language);
      return this.selectAlertContent$(pageName, language).pipe(filter(alertContentEntity => !!alertContentEntity && (alertContentEntity.loaded || alertContentEntity.hasError)));
    }
    getAlertContentByLang$(pageName, lang) {
      return this.store.select(getAlertContentByLang(pageName, lang));
    }
    selectAlertContent$(pageName, language) {
      return this.store.pipe(select(getAlertContent), map(f => f(pageName, language)));
    }
    fetchAlertContent(pageName, language) {
      this.selectAlertContent$(pageName, language).pipe(take(1), tap(alertContentEntity => {
        if (!(alertContentEntity.loading || alertContentEntity.loaded)) {
          this.store.dispatch(fetchAlertContent({
            language,
            pageName
          }));
        }
      })).subscribe();
    }
    static {
      this.ɵfac = function AlertContentFacadeService_Factory(t) {
        return new (t || AlertContentFacadeService)(i0.ɵɵinject(i1$2.Store));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertContentFacadeService,
        factory: AlertContentFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AlertContentFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AlertContentActionTypes, AlertContentFacadeService, AlertContentService, AlertContentStoreModule, clearAlertContents, fetchAlertContent, fetchAlertContentFail, fetchAlertContentSuccess };
